import { checkStatus, generalError, parseJSON } from './utils';

const config = window.config;

// TODO: Set this up to the proper T-Navigator auth
const generateHeaders = (locale, Authorization) => ({
  Accept: 'application/vnd.intrepid+json; version=2',
  'Accept-Language': locale,
  'Content-Type': 'application/json',
  Authorization
});

export const getConversations = (locale, auth) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/travelnavigator/user/communications`,
    {
      method: 'GET',
      headers: generateHeaders(locale, auth)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const getThread = (locale, auth, user) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/travelnavigator/user/${user}/communications`,
    {
      method: 'GET',
      headers: generateHeaders(locale, auth)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const searchUsers = (locale, auth, search_text) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/travelnavigator/user/search?page=1&limit=5`,
    {
      method: 'POST',
      headers: generateHeaders(locale, auth),
      body: JSON.stringify({
        search_type: 'name',
        search_text
      })
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const sendMessage = (locale, auth, userId, messageType, messageData) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/travelnavigator/user/${userId}/${messageType}`,
    {
      method: 'POST',
      headers: generateHeaders(locale, auth),
      body: JSON.stringify(messageData)
    }
  )
    .then(checkStatus)
    .then(parseJSON)
    .catch(generalError);

export const sendFeedback = (locale, auth, body) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/travelnavigator/support/send-email`, {
    method: 'POST',
    headers: generateHeaders(locale, auth),
    body: JSON.stringify(body)
  })
    .then(checkStatus)
    .then(parseJSON)
    .catch(generalError);



// WEBPACK FOOTER //
// ./src/api/messages.js